import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import TuneIcon from "@mui/icons-material/Tune";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { deleteUserFcmToken } from "../services/users";
import Cookies from "js-cookie";

const MOBILE_HEADER_BODY_OFFSET = "calc(50px + env(safe-area-inset-top, 0px))";

const AppHeaderBar = ({ title, setCookies, saveUser, headerRef }) => {
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const user = JSON.parse(localStorage.getItem("user")) || null;
  const history = useHistory();

  useEffect(() => {
    document.documentElement.classList.add("mobile-app-header-active");
    document.body.classList.add("mobile-app-header-active");
    document.body.style.paddingTop = MOBILE_HEADER_BODY_OFFSET;
    return () => {
      document.documentElement.classList.remove("mobile-app-header-active");
      document.body.classList.remove("mobile-app-header-active");
      document.body.style.paddingTop = null;
    };
  }, []);

  useEffect(() => {
    if (!showMenu) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [showMenu]);

  const handleSettingsClick = () => {
    setShowMenu(false);
    history.push("/app/settings");
  };

  const handleHelpClick = () => {
    setShowMenu(false);
    history.push("/app/help");
  };

  const handleLogout = async () => {
    const fcmToken = Cookies.get("fcmToken");

    if (fcmToken) {
      await deleteUserFcmToken(fcmToken);
    }

    await setCookies(null, null, null);
    await saveUser(null);
    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove("fcmToken");
    history.push("/login");
  };

  return (
    <>
      <header className="mobile-app-header" ref={headerRef}>
        <span className="mobile-app-header-title">{title}</span>
        <button
          type="button"
          className="mobile-app-header-profile-button"
          onClick={() => setShowMenu(true)}
          aria-label={t("Account")}
        >
          <PersonIcon />
        </button>
      </header>

      {showMenu && (
        <>
          <button
            type="button"
            className="mobile-profile-overlay"
            aria-label={t("Close")}
            onClick={() => setShowMenu(false)}
          />
          <div
            className="mobile-profile-sheet"
            role="dialog"
            aria-modal="true"
            aria-label={t("Account")}
          >
            <div className="mobile-profile-sheet-header">
              <div className="mobile-profile-sheet-user">
                <div className="mobile-profile-sheet-avatar" aria-hidden>
                  <PersonIcon />
                </div>
                <span className="mobile-profile-sheet-name">
                  {user?.firstName} {user?.lastName}
                </span>
              </div>
              <button
                type="button"
                className="mobile-profile-sheet-close"
                onClick={() => setShowMenu(false)}
                aria-label={t("Close")}
              >
                <FontAwesomeIcon icon="times" />
              </button>
            </div>
            <div className="mobile-profile-sheet-actions">
              <button
                type="button"
                className="mobile-profile-sheet-action"
                onClick={handleSettingsClick}
              >
                <TuneIcon aria-hidden />
                <span>{t("Settings")}</span>
              </button>
              <button
                type="button"
                className="mobile-profile-sheet-action"
                onClick={handleHelpClick}
              >
                <HelpOutlineIcon aria-hidden />
                <span>{t("mobile_support_menu_label")}</span>
              </button>
              <div
                className="mobile-profile-sheet-actions-divider"
                aria-hidden
              />
              <button
                type="button"
                className="mobile-profile-sheet-action mobile-profile-sheet-action-danger"
                onClick={() => void handleLogout()}
              >
                <LogoutIcon aria-hidden />
                <span>{t("Logout")}</span>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AppHeaderBar;
